export default __webpack_public_path__ + "static/media/WerfenDocs_User_Site.48f0c372.pptx";